import * as React from 'react';
import {useSlate} from 'slate-react';
import {Transforms, Editor, Node} from 'slate';

import {BINDED_PILL} from './slateTextUI';

export function useAddToken(onChange: () => void) {
  const editor = useSlate();

  const addToken = React.useCallback(
    (token: string) => {
      Transforms.insertNodes(editor, [
        {
          type: BINDED_PILL,
          token,
          children: [{text: ''}],
        } as Node,
      ]);
      Transforms.move(editor);
      Editor.normalize(editor, {force: true});
      onChange();
    },
    [editor, onChange]
  );

  return addToken;
}
